import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_PROMO_GOODS_SAGA } from "../sagaTypes";
import { loaderAction, promoGoodsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_p_goods`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetPromoGoods(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('establishment', currentEstablishment);
        formData.append('promo_id', args.data.promo_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сохраняем список товаров
            yield put(promoGoodsFormAction({
                open: true,
                promo_id: args.data.promo_id,
                promo_code: args.data.promo_code,
                goods: response.promo_goods
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetPromoGoods() {
    yield takeLatest(GET_PROMO_GOODS_SAGA, workerGetPromoGoods);
}